import React from "react";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import useFinanceToggle from "../../../../hooks/shared/actions/useFinanceToggle";
import * as Styles from "./styles/BasketFinanceTogglePanel";
import * as FinanceToggleStyles from "../../../../../../../common-deprecated/styles/v2/lexus/components/FinanceToggle";
import * as BasketStyles from "../basket/styles/Basket";
import FinanceQuotes from "../FinanceQuotes";
import { useBnbSelector } from "../../../../redux/store";
import Price from "../price/Price";
import BasketCtas from "../basket/content/BasketCtas";
import TotalPriceDisclaimers from "../price/TotalPriceDisclaimers";
import { isRTL } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";

type PropsType = {
    cashPriceDisclaimer?: string | null;
};

const BasketFinanceTogglePanel = (props: PropsType): JSX.Element | null => {
    const { cashPriceDisclaimer } = props;
    const totalPrice = useBnbSelector((state) => state.basket.total);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const step = useBnbSelector(({ navigation }) => navigation.step);
    const modelCode = useBnbSelector((state) => state.car.model.internalCode);

    const financeToggleProps = useFinanceToggle();
    const { setCash, setMonthly } = financeToggleProps;
    const { showMonthlyRateToggle, showCashPrice } = financeToggleProps;
    const { showCashLoader, showMonthlyLoader, showToggles, financeOption } = financeToggleProps;

    const [selectedFinanceOptionTitle, basketTotalMonthlyCosts] = useBnbOptionalLabel([
        "selectedFinanceOptionTitle",
        "basketTotalMonthlyCosts",
    ]);

    return (
        <BasketStyles.BasketHeader isRTL={isRTL(commonSettings)}>
            {showToggles && showMonthlyRateToggle && (
                <FinanceToggleStyles.Wrapper fullWidth isMonthlyActive={financeOption === "monthly"}>
                    <FinanceToggleStyles.ToggleItem
                        isActive={financeOption === "cash"}
                        onClick={() => {
                            if (financeOption === "cash") return;
                            setCash();
                        }}
                    >
                        <FinanceToggleStyles.LineClamp>
                            <BnbLabel label="financeOptionTitleCash" fallbackLabel="financeOptionCash" useHTML />
                        </FinanceToggleStyles.LineClamp>
                    </FinanceToggleStyles.ToggleItem>
                    <FinanceToggleStyles.ToggleItem
                        isActive={financeOption === "monthly"}
                        onClick={() => {
                            if (financeOption === "monthly") return;
                            setMonthly();
                        }}
                    >
                        <FinanceToggleStyles.LineClamp>
                            <BnbLabel label="financeOptionTitleMonthly" fallbackLabel="financeOptionMonthly" useHTML />
                        </FinanceToggleStyles.LineClamp>
                    </FinanceToggleStyles.ToggleItem>
                </FinanceToggleStyles.Wrapper>
            )}
            {financeOption === "cash" ? (
                showCashLoader ? (
                    <Styles.Price>
                        <BnbLabel label="priceLoading" fallbackLabel="spinLoading" />
                    </Styles.Price>
                ) : (
                    <dl>
                        {showMonthlyRateToggle && (
                            <>
                                <dt>{selectedFinanceOptionTitle}</dt>
                                <dd>
                                    <BnbLabel
                                        label="financeOptionTitleCash"
                                        fallbackLabel="financeOptionCash"
                                        useHTML
                                    />
                                </dd>
                            </>
                        )}
                        {showCashPrice && (
                            <>
                                <dt>
                                    <BnbLabel label="basketTotal" />
                                </dt>
                                <dd>
                                    <Price
                                        price={totalPrice}
                                        financeItemId="total"
                                        forceHideMonthlyDisclaimer
                                        showLoader
                                        cashPriceDisclaimer={cashPriceDisclaimer}
                                    />
                                </dd>
                            </>
                        )}
                    </dl>
                )
            ) : showMonthlyLoader ? (
                <Styles.Price>
                    <BnbLabel label="priceLoading" fallbackLabel="spinLoading" />
                </Styles.Price>
            ) : (
                <>
                    <dl>
                        <dt>{selectedFinanceOptionTitle}</dt>
                        <dd>
                            <BnbLabel label="financeOptionTitleMonthly" fallbackLabel="financeOptionMonthly" useHTML />
                        </dd>
                        {basketTotalMonthlyCosts && <dt>{basketTotalMonthlyCosts}</dt>}
                        <dd>
                            <Price
                                price={totalPrice}
                                financeOption="monthly"
                                carInternalCode={modelCode}
                                financeItemId="total"
                            />
                        </dd>
                    </dl>
                    <BasketStyles.FinanceQuotesWrapper>
                        <FinanceQuotes />
                    </BasketStyles.FinanceQuotesWrapper>
                </>
            )}
            <TotalPriceDisclaimers />
            <BasketStyles.HeaderCtaWrapper>
                <BasketCtas step={step} financeOption={financeOption} />
            </BasketStyles.HeaderCtaWrapper>
        </BasketStyles.BasketHeader>
    );
};

export default BasketFinanceTogglePanel;
